const Form1099MiscHelpData = [
  {
    box: 'a',
    title: "Payer's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
    keywords: [
      'Payer',
      'Payer\'s',
      'Name',
      'Street Address',
      'City',
      'Town',
      'State',
      'Province',
      'Country',
      'Zip',
      'Foreign',
      'Postal',
      'Code',
      'Telephone',
      'Phone',
    ],
    details: ['As the payer, enter your business address details.'],
  },
  {
    box: 'b',
    title: "Payer's TIN, also known as federal identification number",
    keywords: [
      'Payer',
      'Payer\'s',
      'Federal',
      'Identification',
      'Number',
      'No',
    ],
    details: ['Enter your federal identification number. You can choose between an EIN or a SSN. If you are the sole proprietor, usually you will enter the SSN which is 9 digits, written ### - ## - ####. Your IRS-assigned EIN is nine digits, written ## - #######.'],
  },
  {
    box: 'c',
    title: "Recipient's TIN, also known as identification number",
    keywords: [
      'Recipient',
      'Recipient\'s',
      'Identification',
      'Number',
      'No',
    ],
    details: ["Enter the recipient's federal identification number. You can choose between an EIN or a SSN. The SSN is 9 digits, written ### - ## - ####. The IRS-assigned EIN is nine digits, written ## - #######."],
  },
  {
    box: 'd',
    title: "Recipient's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
    keywords: [
      'Recipient',
      'Recipient\'s',
      'Name',
      'Payee',
      'Street',
      'Address',
      'Including',
      'Apt',
      'No',
      'Number',
      'City',
      'Town',
      'State',
      'Province',
      'Country',
      'Zip',
      'Foreign',
      'Postal',
      'Code',
    ],
    details: ["Enter the recipient's name and address as it appears on the recipient's Form W-9."],
  },
  {
    box: 'e',
    title: 'Account number (see instructions)',
    keywords: [
      'Account',
      'Number',
      'See',
      'Instruction',
      'Instructions',
    ],
    details: ["If you have more than one account for a recipient and are filing multiple 1099-MISC's for a recipient, include an account number. If you ticked the FATCA filing requirement checkbox, include an account number also."],
  },
  {
    box: 'f',
    title: '2nd TIN not.',
    keywords: [
      '2nd',
      'Tin',
      'Not',
    ],
    details: ['Check this box if the IRS has notified you twice in the last 3 calendar years that your recipient has given you an incorrect TIN. The IRS will not send further notices regarding this recipient if you checked this box.'],
  },
  {
    box: '1',
    title: 'Rents',
    keywords: [
      '1',
      'box 1',
      'Rents',
      'rent',
    ],
    details: ["Enter amounts of $600+ for all rents such as office space rental, machine rental, and pasture rentals. In regards to machine rentals (for example, renting a bulldozer to level your parking lot), if the machine rental is part of a contract that includes both the use of the machine and the operator, prorate the rental between the rent of the machine (report that in box 1) and the operator's charge (report that on Form 1099-NEC in box 1)."],
  },
  {
    box: '2',
    title: 'Royalties',
    keywords: [
      '2',
      'box 2',
      'Royalties',
      'Royalty',
      '1099-NEC',
      '1099-S',
    ],
    details: ['Enter payments for gross royalty of $10+ from oil, gas, or other mineral properties. Also report intangible property such as patents, copyrights, trade names, and trademarks. Do not include surface/land royalties as they should be reported in box 1. Do not report oil or gas payments for a working interest in box 2; report payments for working interest in box 1 of the 1099-NEC. Do not report timber royalties made under a pay-as-cut contract; report these timber royalties on Form 1099-S, Proceeds From Real Estate Transactions.'],
  },
  {
    box: '3',
    title: 'Other Income',
    keywords: [
      '3',
      'box 3',
      'Other',
      'Income',
      '1099-NEC',
    ],
    details: ['Enter amounts of $600+ for other income that you cannot report on any other boxes on this form. This includes prizes and awards that are not for services performed, like winning merchandise on a game show or a sweepstakes not involving a wager. If a wager is made to earn income, report the winnings on Form W-2G. Do not include in box 3 prizes and awards for services performed by nonemployees, such as an award for the top commission salesperson. Report them in box 1 of the 1099-NEC.'],
  },
  {
    box: '4',
    title: 'Federal Income Tax Withheld',
    keywords: [
      '4',
      'box 4',
      'Federal',
      'Income',
      'Tax',
      'Withheld',
    ],
    details: ['Enter your backup withholding. For example, persons who have not furnished their TINs to you are subject to withholding on payments required to be reported in boxes 1, 2 (net of severance taxes), 3, 5 (to the extent paid in cash), 6, 8, 9, and 10.'],
  },
  {
    box: '5',
    title: 'Fishing Boat Proceeds',
    keywords: [
      '5',
      'box 5',
      'Fishing',
      'Boat',
      'Proceeds',
    ],
    details: ['Enter your share of all proceeds from selling catch, the fair market value of a distribution to each crew member of fishing boats with less than 10 crew members, and cash payments up to $100 for each trip that are contingent on a minimum catch and paid for performing additional roles. Do not report any wages reportable on your W-2.'],
  },
  {
    box: '6',
    title: 'Medical and Health Care Payments',
    keywords: [
      '6',
      'box 6',
      'Medical',
      'Health',
      'Payments',
      'Payment',
    ],
    details: ['Enter payments of $600+ to physicians or suppliers of medical/healthcare services during your trade/business. These payments include those made by medical and healthcare insurers under health, accident, and sickness insurance programs.'],
  },
  {
    box: '7',
    title: 'Payer Made Direct Sales of $5,000 or More',
    keywords: [
      '7',
      'box 7',
      '5000',
      'Consumer',
      'Buy',
      'Sell',
      'Commission',
    ],
    details: ['Check this box if you made direct sales of $5000+ of consumer products to a recipient on a buy-sell, deposit-commission, or other commission basis anywhere other than a permanent retail establishment.'],
  },
  {
    box: '8',
    title: 'Substitute Payments in Lieu of Dividends or Interest',
    keywords: [
      '8',
      'box 8',
      'Substitute',
      'Payment',
      'Payments',
      'Lieu',
      'Dividends',
      'Interest',
    ],
    details: ["Enter payments of $10+ from a broker to a customer in place of dividends or tax-exempt interest, resulting from a customer's security loan."],
  },
  {
    box: '9',
    title: 'Crop Insurance Proceeds',
    keywords: [
      '9',
      'box 9',
      '600',
      'Farmer',
    ],
    details: ['Enter payments of $600+ to a farmer if you are an insurance company.'],
  },
  {
    box: '10',
    title: 'Gross Proceeds Paid to an Attorney',
    keywords: [
      '10',
      'box 10',
      'Gross',
      'Proceed',
      'Proceeds',
      'Paid',
      'Attorney',
      '600',
    ],
    details: ['Enter payments of $600+ to an attorney for legal services.'],
  },
  {
    box: '11',
    title: 'Fish Purchased for Resale',
    keywords: [
      '11',
      'box 11',
      '600',
      'Fish',
      'Resale',
    ],
    details: ['Enter payments of $600+ paid during the year to any person who is engaged in the trade or business of catching fish.'],
  },
  {
    box: '12',
    title: 'Section 409A deferrals',
    keywords: [
      '12',
      'box 12',
      '2008-115',
      'Defer',
      'Nonemployee',
      '600',
      'Deferrals',
    ],
    details: ['You do not have to complete this box. For more information see Notice 2008-115, available at IRS.gov/irb/2008-52_IRB#NOT-2008-115.', 'If you complete this box, enter deferred payments of $600+ to a nonemployee under nonqualified plans.'],
  },
  {
    box: '13',
    title: 'FATCA filing requirement checkbox',
    keywords: [
      'FATCA',
      'Filing',
      'Requirement',
      '13',
      'box 13',
    ],
    details: ['According to Regulations section 1.1471-4(d)(2)(iii)(A), check this box if you are a US payer reporting a 1099-MISC to satisfy your requirement to report due to a US account for chapter 4 purposes.', 'According to Regulations section 1.1471-4(d)(5)(i)(A), check this box if you are a foreign financial institution (FFI) reporting payments to a US account for a described election, or making the election described and reporting a US account for chapter 4 purposes that you did not pay during any reportable year or any applicable 1099-MISC.'],
  },
  {
    box: '14',
    title: 'Excess Golden Parachute Payments',
    keywords: [
      '14',
      'box 14',
      'Excess',
      'Golden',
      'Parachute',
      'Payment',
      'Payments',
    ],
    details: ["Enter payments to employees that receive benefits of three time's their base upon a change in ownership or control of the company."],
  },
  {
    box: '15',
    title: 'Nonqualified Deferred Compensation',
    keywords: [
      '15',
      'box 15',
      '409A',
      'Section',
      'Income',
    ],
    details: ['Enter deferred payments for nonemployees under nonqualified plans that do not satisfy the requirements of section 409A that can be included as income. Do not include income that was previously reported on a W-2 or 1099-MISC for a prior year.'],
  },
  {
    box: '16',
    title: 'State Tax Withheld',
    keywords: [
      '16',
      'box 16',
      'State',
      'Tax',
      'Withheld',
    ],
    details: ['If you participate in the Combined Federal/State Filing Program and/or are required to file paper copies of the 1099-MISC with a state tax department, enter withheld state income tax for up to two states.'],
  },
  {
    box: '17',
    title: "State/Payer's State no.",
    keywords: [
      '17',
      'box 17',
      'State',
      'Payer',
      'Payer\'s',
      'State',
      'No',
      'Number',
    ],
    details: ['If you participate in the Combined Federal/State Filing Program and/or are required to file paper copies of the 1099-MISC with a state tax department, enter the abbreviated name of the state and your state identification number assigned by the state.'],
  },
  {
    box: '18',
    title: 'State Income',
    keywords: [
      '18',
      'box 18',
      'State',
      'Income',
    ],
    details: ['If you participate in the Combined Federal/State Filing Program and/or are required to file paper copies of the 1099-MISC with a state tax department, enter the state payment.'],
  },
];

export default Form1099MiscHelpData;



// WEBPACK FOOTER //
// ./src-react/VisualStatic/HelpData/Form1099MiscHelpData.js